import { version } from '../../package.json';

export const APP_NAME = 'Ubiwan Connect Web';
export const APP_VERSION = version;
